import { useEffect } from 'react';
// TODO think about location
import { screenComponents } from 'core/common/ui/pages';
import { ScreenType } from 'core/flow/entities';

type ScreenPreloaderProps = {
  isInitialScreen: boolean;
  screenType: ScreenType;
  nextScreenType: ScreenType | null;
};

export const ScreenPreloader = ({
  isInitialScreen,
  screenType,
  nextScreenType,
}: ScreenPreloaderProps) => {
  useEffect(() => {
    const currentScreen = screenComponents[screenType];
    const nextScreen = nextScreenType ? screenComponents[nextScreenType] : null;

    if (isInitialScreen && currentScreen) {
      currentScreen.importChunk();
    }

    if (nextScreen) {
      nextScreen.importChunk();
    }
  }, [isInitialScreen, screenType, nextScreenType]);

  return null;
};
